import { render, staticRenderFns } from "./PlacementsSingleDetailsCard.vue?vue&type=template&id=4a787741&"
import script from "./PlacementsSingleDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingleDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports